import { createSelector } from 'reselect';
import * as sites from 'ducks/sites';
import * as employees from 'ducks/employees';
import * as employeeInfoDuck from 'ducks/employeeInfo';
import * as clients from 'ducks/clients';
import * as mobilePatrols from 'ducks/mobile-patrols';
import * as contacts from 'ducks/contacts';
import * as forms from 'ducks/forms';
import * as tasks from 'ducks/tasks';
import * as tours from 'ducks/tours';
import * as auditLog from 'ducks/auditLog';
import * as visitors from 'ducks/visitors';
import * as visitorLog from 'ducks/visitorLog';
import * as siteInfo from 'ducks/siteInfo';
import * as branches from 'ducks/branches';
import * as administrators from 'ducks/administrators';
import * as mobileRoutes from 'ducks/mobileRoutes';

export const selectBreadcrumbsState = createSelector(
  sites.selectors,
  employees.selectors,
  clients.selectors,
  mobilePatrols.selectors,
  contacts.selectors,
  forms.selectors,
  tasks.selectors,
  tours.selectors,
  auditLog.selectors,
  visitors.selectors,
  visitorLog.selectors,
  siteInfo.selectors,
  branches.selectors,
  administrators.selectors,
  employeeInfoDuck.selectors,
  mobileRoutes.selectors,
  (
    { list: sitesList },
    { list: employeesList },
    { list: clientsList },
    { list: mobilePatrolsList },
    { info: contactInfo },
    { info: formInfo },
    { info: taskInfo },
    { info: tourInfo },
    { info: auditLogInfo },
    { info: visitorsInfo },
    { info: visitorLogInfo },
    { siteInformation },
    { info: branchInfo },
    { info: administratorInfo },
    employeeInfo,
    { list: { rows: mobileRoutesList }, selected: mobileRouteSelected }
  ) => ({
    sitesList,
    employeesList,
    clientsList,
    mobilePatrolsList,
    contactInfo,
    formInfo,
    taskInfo,
    tourInfo,
    auditLogInfo,
    visitorsInfo,
    visitorLogInfo,
    siteInformation,
    branchInfo,
    administratorInfo,
    employeeInfo,
    mobileRoutesList,
    mobileRouteSelected,
  })
);
